/**
 * Suporta produtos com uma ou várias categorias:
 * - Preferência: `categorias` (array de strings)
 * - Legado: `categoria` (string única)
 */

function normalizeList(raw) {
    if (!Array.isArray(raw)) return [];
    const out = [];
    const seen = new Set();
    for (const item of raw) {
        const s = String(item ?? "").trim();
        if (!s || seen.has(s)) continue;
        seen.add(s);
        out.push(s);
    }
    return out;
}

export function getProductCategorias(product) {
    if (!product) return [];
    const fromArray = normalizeList(product.categorias);
    if (fromArray.length > 0) return fromArray;
    const single = product.categoria;
    if (single != null && String(single).trim()) return [String(single).trim()];
    return [];
}

export function getProductCategoriaLabel(product, separator = " · ") {
    const list = getProductCategorias(product);
    if (!list.length) return "";
    return list.join(separator);
}

export function productMatchesCategoriaFilters(product, selectedCategories) {
    if (!selectedCategories || selectedCategories.length === 0) return true;
    const cats = getProductCategorias(product);
    return cats.some((c) => selectedCategories.includes(c));
}

export function productCategoriasOverlap(productA, productB) {
    const a = getProductCategorias(productA);
    const b = new Set(getProductCategorias(productB));
    return a.some((c) => b.has(c));
}

export function productHasVapeCategory(product) {
    return getProductCategorias(product).some((c) => String(c).toLowerCase() === "vape");
}
